<template>
  <div ref="host" class="ocr-plotly-host" :style="{ minHeight: height + 'px' }" />
</template>

<script>
import Plotly from "plotly.js-dist-min";
import { mapGetters } from "vuex";
import { mergePlotlyTheme } from "@/utils/chartTheme";

export default {
  name: "OcrPlotlyChart",
  props: {
    data: { type: Array, default: () => [] },
    layout: { type: Object, default: () => ({}) },
    config: { type: Object, default: () => ({ displayModeBar: false, responsive: true }) },
    height: { type: Number, default: 260 },
  },
  computed: {
    ...mapGetters("darkMode", ["isDarkMode"]),
  },
  watch: {
    data: { deep: true, handler() { this.render(); } },
    layout: { deep: true, handler() { this.render(); } },
    isDarkMode() { this.render(); },
  },
  mounted() {
    this.render();
    this._ro = new ResizeObserver(() => this.resize());
    if (this.$refs.host) this._ro.observe(this.$refs.host);
  },
  beforeUnmount() {
    if (this._ro) this._ro.disconnect();
    if (this.$refs.host) Plotly.purge(this.$refs.host);
  },
  methods: {
    resize() {
      if (this.$refs.host && this.$refs.host.data) {
        Plotly.Plots.resize(this.$refs.host);
      }
    },
    render() {
      const el = this.$refs.host;
      if (!el || !this.data?.length) return;
      const themed = mergePlotlyTheme(
        {
          ...this.layout,
          height: this.height,
          margin: this.layout.margin || { l: 40, r: 12, t: 10, b: 36, pad: 0 },
          paper_bgcolor: "rgba(0,0,0,0)",
          plot_bgcolor: "rgba(0,0,0,0)",
        },
        this.isDarkMode
      );
      Plotly.react(el, this.data, themed, this.config);
    },
  },
};
</script>
